import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/accessibility.css'
import './styles/grid.css'
import './index.css'

// Ensure the root element exists
const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

